<template>
    <div class="part-item">
        <div class="item-header">
            <h1 class="item-title"><i class="fa fa-stop part-item-title"></i>{{ title }}</h1>
            <slot name="header-right"></slot>
        </div>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: ['title']
    }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    @import "../../assets/scss/lib.scss";

    .part-item {
        width: 1080px;
        margin: 45px auto;
    }

    .item-header {
        @include flex;
        @include main-justify;
        @include cross-center;
        width: 100%;
        height: 80px;
        margin-top: -40px;
    }

    .part-item-title {
        transform: rotate(45deg);
        font-size: 22px;
        margin-right: 10px;
    }

    .item-title {
        color: $orange-color;
        font-size: 26px;
    }
</style>


// WEBPACK FOOTER //
// PartItem.vue?5f670cd9